module.exports = __webpack_public_path__ + "img/unlock-button-infiniti.ede24f3a.png";